<app-topnav></app-topnav>
<router-outlet></router-outlet>
<app-loader *ngIf="s.loader || auS.loader"></app-loader>